import { Component, Inject, Input, OnInit } from '@angular/core';
import { TranslateService }                 from '@ngx-translate/core';
import { UIRouter }                         from '@uirouter/core';

import { AJS_VENDOR }               from '../vendors/vendor.quick-add.provider.ajs';
import { AjsVendorQuickAddModel }   from '../vendors/typings/vendors.ajs-quick-add';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { MessagesService }          from '../messages/messages.service';
import { PartsAuthorityService }    from './parts-authority.service';
import { VendorModel }              from '../vendors/models/vendor';
import { VendorSearchService }      from '../vendors/vendor.search.service';

@Component({
  selector   : 'wor-parts-authority-settings',
  template: require('./parts-authority.settings.component.html')
})
export class PartsAuthoritySettingsComponent implements OnInit {
  @Input() integrations : CompanyIntegrationsModel;

  title  : string = this.partsAuthorityService.title;
  vendor : Partial<VendorModel> | string;

  constructor (
    @Inject(AJS_VENDOR)
    private ajsVendor            : AjsVendorQuickAddModel,
    public  companyService       : CompanyService,
    private messagesService      : MessagesService,
    private partsAuthorityService: PartsAuthorityService,
    private router               : UIRouter,
    private translateService     : TranslateService,
    private vendorSearchService  : VendorSearchService
  ) {}

  activate () : void {
    this.partsAuthorityService.activate()
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
          name: this.title
        }), 'success');

        this.router.stateService.reload();
      })
      .catch(err => this.messagesService.error(err));
  }

  format = ( vendor : Partial<VendorModel> | string ) : string => {
    return typeof vendor === 'object' && vendor
      ? vendor.company_name || ''
      : vendor as string || '';
  };

  newVendor () : void {
    this.ajsVendor.quickAdd()
      .then(( vendor : VendorModel ) => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {
          name: this.title
        }), 'success');

        this.setVendor(vendor);

        this.vendor = vendor;
      })
      // The window rejects only when it is closed without saving, which is not an error.
      .catch(() => null);
  }

  ngOnInit () : void {
    this.vendor = {
      company_name: this.integrations.parts_authority_vendor_name,
      id          : this.integrations.parts_authority_vendor_id
    };
  }

  remove () : void {
    this.partsAuthorityService.remove()
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVED', {
          name: this.title
        }), 'success');

        this.router.stateService.reload();
      })
      .catch(err => this.messagesService.error(err));
  }

  save () : void {
    this.partsAuthorityService.save(this.integrations)
      .then(() => {
        this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');

        this.router.stateService.reload();
      })
      .catch(err => this.messagesService.error(err));
  }

  search = ( typed : string ) : ng.IPromise<Array<VendorModel>> => {
    return this.vendorSearchService.search(typed);
  };

  setVendor ( vendor : VendorModel ) : void {
    this.integrations.parts_authority_vendor_id   = vendor.id;
    this.integrations.parts_authority_vendor_name = vendor.company_name;
  }
}
